export const navLinks = [
  { label: '首页', href: '/' },
  { label: '产品分类', href: '/categories' },
  { label: '文章资讯', href: '/articles' },
  { label: '关于我们', href: '/about' },
];

export const heroContent = {
  title: '久久草',
  subtitle: '品质保证，正品直达',
  description: '久久草精选优良草种与草皮品种，为庭院、运动场、园林绿化提供专业草坪解决方案。从选种到养护，久久草全程陪伴，让每一寸绿地都经久耐用。',
  ctaPrimary: '了解产品',
  ctaSecondary: '联系我们',
};

export const categoryItems = [
  {
    id: 'turf',
    name: '草坪草皮',
    description: '高品质成品草皮，即铺即绿，适用于庭院、公园、高尔夫球场等各类场景。',
    icon: 'ri-plant-line',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20lush%20green%20turf%20grass%20lawn%20rolls%20stacked%20neatly%20in%20a%20garden%20center%2C%20natural%20sunlight%2C%20vibrant%20green%20color%2C%20professional%20landscaping%20product%20photography%2C%20clean%20background%20with%20soft%20natural%20shadows%2C%20high%20detail%20texture%20showing%20healthy%20grass%20blades&width=800&height=600&seq=turf-category-01&orientation=landscape',
  },
  {
    id: 'seeds',
    name: '优质草种',
    description: '进口与国产优良草种，耐寒耐旱、抗病虫害，发芽率高，成坪速度快。',
    icon: 'ri-seedling-line',
    image: 'https://readdy.ai/api/search-image?query=High%20quality%20grass%20seeds%20in%20small%20burlap%20sacks%20on%20a%20wooden%20table%2C%20warm%20natural%20lighting%2C%20rustic%20garden%20aesthetic%2C%20some%20seeds%20scattered%20artistically%2C%20professional%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20earthy%20tones%20and%20green%20accents&width=800&height=600&seq=seeds-category-02&orientation=landscape',
  },
  {
    id: 'service',
    name: '绿化服务',
    description: '专业绿化设计与施工团队，提供草坪铺设、园林绿化、养护管理一站式服务。',
    icon: 'ri-tools-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20landscaping%20team%20working%20on%20a%20beautiful%20green%20lawn%20installation%2C%20workers%20laying%20fresh%20turf%20rolls%2C%20modern%20garden%20design%2C%20bright%20sunny%20day%2C%20clean%20and%20organized%20worksite%2C%20high%20quality%20editorial%20photography%2C%20natural%20colors&width=800&height=600&seq=service-category-03&orientation=landscape',
  },
  {
    id: 'maintenance',
    name: '养护用品',
    description: '专业草坪肥料、除草剂、土壤改良剂，为草坪健康生长提供全面保障。',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Garden%20lawn%20care%20products%20displayed%20on%20a%20clean%20wooden%20shelf%2C%20organic%20fertilizers%20and%20natural%20soil%20conditioners%20in%20beautiful%20packaging%2C%20soft%20natural%20light%20from%20window%2C%20green%20plants%20decorating%20the%20scene%2C%20professional%20product%20photography%2C%20warm%20earthy%20aesthetic&width=800&height=600&seq=maintenance-category-04&orientation=landscape',
  },
];

export const advantageItems = [
  {
    id: 1,
    title: '品种优良',
    description: '久久草与国内外多家知名草种研究机构合作，精选高适应性、高观赏性草种，确保每一批产品都经得起时间考验。',
    icon: 'ri-medal-line',
  },
  {
    id: 2,
    title: '品质保证',
    description: '从源头到交付，久久草建立严格的质量管控体系。每批草皮出厂前经过多道检测，确保无病虫害、根系发达、色泽统一。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 3,
    title: '专业服务',
    description: '久久草拥有经验丰富的绿化工程师团队，提供从场地勘测、方案设计到施工养护的全流程专业服务。',
    icon: 'ri-team-line',
  },
  {
    id: 4,
    title: '快速配送',
    description: '久久草自建物流体系，草皮从收割到送达不超过24小时，确保产品新鲜度与成活率。覆盖全国主要城市的配送网络。',
    icon: 'ri-truck-line',
  },
  {
    id: 5,
    title: '售后无忧',
    description: '久久草提供完善的售后服务保障，草皮铺设后出现任何质量问题，免费补换。专业的养护指导让您无后顾之忧。',
    icon: 'ri-heart-line',
  },
  {
    id: 6,
    title: '环保理念',
    description: '久久草坚持绿色可持续发展理念，所有产品采用生态种植方式，不使用有害化学物质，让您的草坪真正健康环保。',
    icon: 'ri-leaf-line',
  },
];

export const caseItems = [
  {
    id: 1,
    title: '北京奥林匹克公园草坪项目',
    description: '久久草为北京奥林匹克公园提供超过5万平方米优质草坪，涵盖景观草坪与运动草坪，历经多年仍保持优良状态。',
    location: '北京',
    area: '50,000㎡',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20large%20public%20park%20with%20lush%20green%20expansive%20lawn%2C%20people%20enjoying%20the%20grass%20under%20sunny%20sky%2C%20modern%20urban%20landscape%20design%2C%20clean%20manicured%20grass%20with%20walking%20paths%2C%20professional%20landscape%20photography%2C%20bright%20natural%20lighting&width=800&height=600&seq=case-01-park&orientation=landscape',
  },
  {
    id: 2,
    title: '上海某高端别墅庭院绿化',
    description: '为上海佘山区域高端别墅群提供定制化庭院草坪方案，精选耐阴草种搭配景观设计，打造私密花园空间。',
    location: '上海',
    area: '3,000㎡',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20private%20villa%20garden%20with%20perfectly%20manicured%20green%20lawn%2C%20modern%20architecture%20background%2C%20ornamental%20trees%20and%20flowering%20shrubs%2C%20beautiful%20landscape%20design%2C%20golden%20hour%20warm%20sunlight%2C%20professional%20real%20estate%20photography&width=800&height=600&seq=case-02-villa&orientation=landscape',
  },
  {
    id: 3,
    title: '广州某国际学校运动场',
    description: '久久草为广州国际学校铺设专业级运动草坪，采用耐踩踏品种，满足足球、橄榄球等高强度运动需求。',
    location: '广州',
    area: '8,000㎡',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20field%20with%20vibrant%20green%20natural%20grass%2C%20soccer%20field%20markings%20visible%2C%20modern%20school%20buildings%20in%20background%2C%20bright%20sunny%20day%2C%20well%20maintained%20athletic%20turf%2C%20professional%20sports%20photography%20style%2C%20clean%20crisp%20image&width=800&height=600&seq=case-03-school&orientation=landscape',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '久久草的草皮品种主要有哪些？',
    answer: '久久草主要提供百慕大草（狗牙根）、结缕草（马尼拉草）、高羊茅、黑麦草、早熟禾等多个品种。不同品种适用于不同的气候环境和用途，我们的专业顾问会根据您的具体需求推荐最合适的品种。百慕大草耐热耐旱适合南方，结缕草耐寒耐阴适合北方，高羊茅和黑麦草则适用于过渡地带。',
  },
  {
    id: 2,
    question: '草皮铺设后多久可以正常使用？',
    answer: '一般情况下，久久草草皮铺设后2-3周即可生根固定，4-6周后可正常使用。具体时间取决于季节、温度、水分管理等条件。春季和秋季是最佳铺设季节，草皮恢复速度最快。铺设后前两周需要保持充足水分，避免踩踏，确保草皮与土壤充分结合。我们的施工团队会提供详细的养护指导。',
  },
  {
    id: 3,
    question: '久久草的产品价格如何？怎么获取报价？',
    answer: '久久草产品价格根据品种、规格、数量及距离等因素有所不同。您可以通过官网在线咨询、拨打客服热线或直接访问线下门店获取最新报价。我们承诺价格透明、性价比高，并提供免费上门勘测服务。批量采购还可享受阶梯优惠价格，长期合作客户更有专属折扣方案。',
  },
  {
    id: 4,
    question: '久久草支持全国发货吗？运输过程中草皮会不会受损？',
    answer: '久久草目前支持全国主要城市配送，采用专业保鲜运输方式。草皮在收割后立即打包，使用保湿材料进行防护，确保运输过程中保持新鲜。我们承诺从收割到送达不超过24小时（部分偏远地区可能略有延长）。如运输过程中出现质量问题，久久草承诺免费更换。',
  },
  {
    id: 5,
    question: '久久草的草种发芽率如何？有质量保证吗？',
    answer: '久久草的草种均来自正规渠道，发芽率稳定在85%以上（远高于国家标准75%）。每批草种都经过严格检测，附有质量检测报告。我们提供播种技术指导和售后跟踪服务，如按规范操作后发芽率不达标，久久草承诺免费补发种子或退款处理。',
  },
  {
    id: 6,
    question: '如何选择适合我家庭院的草坪品种？',
    answer: '选择草坪品种需要考虑多个因素：当地气候条件（温度、降水）、日照情况（全日照还是半阴）、使用需求（观赏还是活动）、维护能力等。久久草提供免费的专业咨询服务，您可以联系我们的绿化工程师，他们会根据您的实际情况推荐最合适的品种，并提供完整的种植和养护方案。',
  },
];

export const ctaContent = {
  title: '让久久草为您打造理想绿地',
  description: '无论您是庭院美化、园林工程还是运动场地建设，久久草都能为您提供专业、可靠的草坪解决方案。现在就联系我们，开启您的绿色之旅。',
  buttonText: '立即咨询',
};

export const footerContent = {
  brandName: '久久草',
  description: '久久草——品质保证，正品直达。专业草坪草皮、草种及绿化解决方案提供商，致力于为每一个空间带来持久美丽的绿色。',
  contact: {
    phone: '400-888-9999',
    email: 'contact@jiujiucao.com',
    address: '北京市朝阳区绿化路88号久久草大厦',
    workingHours: '周一至周日 8:00 - 18:00',
  },
  quickLinks: [
    { label: '产品分类', href: '/categories' },
    { label: '文章资讯', href: '/articles' },
    { label: '关于我们', href: '/about' },
  ],
  socialLinks: [
    { icon: 'ri-wechat-line', label: '微信公众号' },
    { icon: 'ri-weibo-line', label: '微博' },
    { icon: 'ri-tiktok-line', label: '抖音' },
  ],
};

export const statsItems = [
  { value: '15+', label: '年行业经验' },
  { value: '500+', label: '服务项目' },
  { value: '200万+', label: '平方米铺设面积' },
  { value: '98%', label: '客户满意度' },
];